import { DataStore } from './DataStore';

/**
 * Wrapper for sessionStorage to simplify storing and loading of JSON objects
 */
export const SessionStore = new DataStore(sessionStorage);
